"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cosmosSignTx = exports.cosmosGetAddress = void 0;
const crypto_1 = require("@cosmjs/crypto");
const core = __importStar(require("@shapeshiftoss/hdwallet-core"));
const base64_js_1 = require("base64-js");
const p_lazy_1 = __importDefault(require("p-lazy"));
const utils_1 = require("./utils");
const protoTxBuilder = p_lazy_1.default.from(() => Promise.resolve().then(() => __importStar(require("@shapeshiftoss/proto-tx-builder"))));
const ATOM_CHAIN = "cosmoshub-4";
const cosmosGetAddress = (transport, msg) => __awaiter(void 0, void 0, void 0, function* () {
    const bip32path = core.addressNListToBIP32(msg.addressNList);
    const res = yield transport.call("Cosmos", "getAddress", bip32path, "cosmos", msg.showDisplay);
    (0, utils_1.handleError)(res, transport, "Unable to obtain address from device.");
    return res.payload.address;
});
exports.cosmosGetAddress = cosmosGetAddress;
const cosmosSignTx = (transport, msg) => __awaiter(void 0, void 0, void 0, function* () {
    const bip32path = core.addressNListToBIP32(msg.addressNList);
    const getAddressResponse = yield transport.call("Cosmos", "getAddress", bip32path, "cosmos", false);
    (0, utils_1.handleError)(getAddressResponse, transport, "Unable to obtain address and public key from device.");
    const { address, publicKey } = getAddressResponse.payload;
    const unsignedTx = (0, utils_1.stringifyKeysInOrder)({
        account_number: msg.account_number,
        chain_id: ATOM_CHAIN,
        fee: { amount: msg.tx.fee.amount, gas: msg.tx.fee.gas },
        memo: msg.tx.memo,
        msgs: msg.tx.msg,
        sequence: msg.sequence,
    });
    const signResponse = yield transport.call("Cosmos", "sign", bip32path, unsignedTx);
    (0, utils_1.handleError)(signResponse, transport, "Unable to obtain signature from device.");
    const signature = signResponse.payload.signature;
    if (!signature)
        throw new Error("No signature returned from device");
    const offlineSigner = {
        getAccounts() {
            return __awaiter(this, void 0, void 0, function* () {
                return [
                    {
                        address,
                        algo: "secp256k1",
                        pubkey: Buffer.from(publicKey, "hex"),
                    },
                ];
            });
        },
        signAmino(signerAddress, signDoc) {
            return __awaiter(this, void 0, void 0, function* () {
                if (signerAddress !== address)
                    throw new Error("expected signerAddress to match address");
                return {
                    signed: signDoc,
                    signature: {
                        pub_key: {
                            type: "tendermint/PubKeySecp256k1",
                            value: publicKey,
                        },
                        signature: (0, base64_js_1.fromByteArray)(crypto_1.Secp256k1Signature.fromDer(signature).toFixedLength()),
                    },
                };
            });
        },
    };
    const signerData = {
        sequence: Number(msg.sequence),
        accountNumber: Number(msg.account_number),
        chainId: msg.chain_id,
    };
    return (yield protoTxBuilder).sign(address, msg.tx, offlineSigner, signerData, "cosmos");
});
exports.cosmosSignTx = cosmosSignTx;
//# sourceMappingURL=cosmos.js.map